import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BioConnectUser, User } from './user-service.types';
import { UserConfig } from './user-service.types';
import { PagedResponse } from '@bioconnect-ui/shared-service';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient,
    @Inject('UserConfig') private UserConfig: UserConfig) { }

  private restServer = this.UserConfig.restServer;

  /**
   * Get the user details for the logged in user
   */
  getUserDetails(): Observable<BioConnectUser> {
    return this.httpClient.get(`${this.restServer}/users/bioconnect_user/current_user_details/`)
      .pipe(map(result => {
        return <BioConnectUser>result;
      }));
  }

  /**
   * Get a list of all bioconnect users
   */
  getUsers(): Observable<User[]> {
    return this.httpClient.get<PagedResponse>(`${this.restServer}/users/bioconnect_user/?page_size=500`)
      .pipe(map(result => {
        const userList = <BioConnectUser[]>result.results;
        return userList.map(u => u.user as User);
      }));
  }

  /**
   * Get a list of all bioconnect users
   */
  getUserNames(): Observable<string[]> {
    return this.httpClient.get<PagedResponse>(`${this.restServer}/users/bioconnect_user/?page_size=500`)
      .pipe(map(result => {
        const userList = <BioConnectUser[]>result.results;
        return userList.map(u => u.user.email);
      }));
  }
}